// extracted by mini-css-extract-plugin
module.exports = {"filesContainer":"PosDisputesFiles_filesContainer__3xTW8","filesListContainer":"PosDisputesFiles_filesListContainer__2v4zj","filesButton":"PosDisputesFiles_filesButton__2Soxh"};